import { render, staticRenderFns } from "./IconRejection.vue?vue&type=template&id=289ca050&"
import script from "./IconRejection.vue?vue&type=script&lang=js&"
export * from "./IconRejection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports